export const MODES = {
  LOGIN: "login",
  REGISTRATION: "registration",
  RESET: "reset",
};

export const info = [
  {
    title: "Կանխատեսումները չեն մնում խոսքի մակարդակում",
    description:
      "Համակարգը հետևում է դրանց իրականացմանը և փոփոխում հեղինակների  վարկանիշները։",
  },
  {
    title: "Օբյեկտիվ գնահատման մեխանիզմ",
    description:
      "Վարկանիշները ձևավորվում են կանխատեսումների ճշգրտության հիման վրա։",
  },
  {
    title: "Հետևեք ճշգրիտ կանխատեսողներին",
    description:
      "Բացահայտեք սխալվողներին և տեսեք, թե ինչպես են իրադարձությունները ձևավորում վարկանիշները։",
  },
  {
    title: "Prognos-ը ձեր կողմնացույցն է ապագայի տեսլականների աշխարհում: ",
    description: "Վստահեք փաստերին, ոչ թե դատարկ խոստումներին։",
  },
];
